import { watchOpenStore } from '../store/uiStore'

// ============================================================
// IL NEGOZIO SHOPIFY DIETRO AL MONDO 3D.
//
// Il dominio sta anche in index.js (l'indirizzo della Storefront API):
// qui serve per i link a PAGINE, non alla API.
// ============================================================
// Dal 14/09/2026 il dominio principale di Shopify e' un sottodominio di
// momoz.shop: al pagamento e nell'account il cliente resta "in casa" invece
// di vedersi comparire 3utay1-jd.myshopify.com, che fa perdere fiducia.
// Il vecchio dominio funziona lo stesso (Shopify rimanda qui), ma i link
// vanno fatti su questo.
export const DOMINIO_SHOPIFY = 'negozio.momoz.shop'

// L'ACCOUNT CLIENTE LO FA SHOPIFY, NON NOI (scelta presa con l'utente fra
// due strade). Questo indirizzo rimanda da solo alla pagina di accesso dei
// "nuovi account cliente": si entra con l'email e un codice usa e getta,
// niente password, e li' dentro ci sono ordini, stato delle spedizioni e
// indirizzi. Il vantaggio grosso e' che i dati dei clienti restano a
// Shopify: noi non tocchiamo ne' password ne' anagrafiche.
// L'alternativa era l'accesso DENTRO il gioco (Customer Account API, OAuth
// e token da rinnovare nel browser): piu' bella, ma non aggiunge niente
// che il cliente non abbia gia' qui — vedi CLAUDE.md.
// Si passa dal dominio myshopify e non dall'indirizzo finale
// (shopify.com/<numero>/account) perche' quel numero e' un dettaglio
// interno: Shopify ci rimanda da solo, con la lingua giusta.
export const URL_ACCOUNT = `https://${DOMINIO_SHOPIFY}/account`

// SI APRE IN UNA FINESTRA POPUP, NON IN UNA SCHEDA (chiesto dall'utente):
// piccola e centrata sullo schermo, col negozio che resta dietro, visibile.
// DENTRO LA PAGINA NON SI PUO': le pagine account di Shopify vietano di
// essere incorniciate (x-frame-options: DENY e frame-ancestors 'none'), e
// un iframe resterebbe bianco. Verificato sulle intestazioni vere.
// Il nome della finestra la fa RIUSARE: riaprendo l'account non si
// accumulano popup, torna davanti quella che c'e' gia'.
// Va chiamata DENTRO un gesto dell'utente (click sul quadrante, tasto), o
// il browser la blocca; se la blocca lo stesso, si ripiega sulla scheda.
const POPUP_L = 520
const POPUP_A = 760
export function apriAccount() {
  const x = window.screenX + Math.max(0, (window.outerWidth - POPUP_L) / 2)
  const y = window.screenY + Math.max(0, (window.outerHeight - POPUP_A) / 2)
  const finestra = window.open(
    URL_ACCOUNT, 'momoz-account',
    `popup=yes,width=${POPUP_L},height=${POPUP_A},left=${Math.round(x)},top=${Math.round(y)}`
  )
  if (finestra) finestra.focus()
  else window.open(URL_ACCOUNT, '_blank', 'noopener,noreferrer')
  watchOpenStore.set(false)
}
